module.exports = __webpack_public_path__ + "img/52114130_L.08839cab.png";